// extracted by mini-css-extract-plugin
export var header = "Header-module--header--8eixD";
export var rightSide = "Header-module--right-side--wsYcX";
export var title = "Header-module--title--ETj7Q";
export var navbarContainer = "Header-module--navbar-container--7GX0M";
export var toggle = "Header-module--toggle--5vGA9";
export var darkTheme = "Header-module--dark-theme--lAhq3";
export var reactToggleChecked = "Header-module--react-toggle--checked--oFyG4";
export var reactToggleTrack = "Header-module--react-toggle-track--CnzEj";